import React from 'react';
import { StaticQuery, graphql } from 'gatsby';

import SeeMore from './SeeMore';
import {
  vaellukset,
  hiihtovaellukset,
  maastopyoraily,
  vapaalasku,
  verkkokurssit,
} from '../../information/camps';

// eslint-disable-next-line react/prop-types
const SeeMoreCamps = ({ camp }) => (
  <StaticQuery
    query={graphql`
      {
        hike1: file(
          relativePath: { eq: "images/hikes/2022-hetta-pallas-1.jpg" }
        ) {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        hike2: file(
          relativePath: { eq: "images/hikes/hetta_pallas_2048px-2.jpg" }
        ) {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        hike3: file(relativePath: { eq: "images/hikes/Hike-Halti-2.jpg" }) {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        hike4: file(relativePath: { eq: "images/hikes/norway-hike-1.jpg" }) {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        crossCountry1: file(
          relativePath: {
            eq: "images/crosscountry/hettapallas-hiihtovaellus-2023-2.jpg"
          }
        ) {
          childImageSharp {
            gatsbyImageData(quality: 90, layout: FULL_WIDTH)
          }
        }
        crossCountry2: file(
          relativePath: { eq: "images/crosscountry/Ahkio-Halti.jpeg" }
        ) {
          childImageSharp {
            gatsbyImageData(quality: 90, layout: FULL_WIDTH)
          }
        }
        crossCountry3: file(
          relativePath: { eq: "images/crosscountry/kaamoshiihto-7.jpg" }
        ) {
          childImageSharp {
            gatsbyImageData(quality: 90, layout: FULL_WIDTH)
          }
        }
        crossCountry4: file(
          relativePath: { eq: "images/crosscountry/uudenvuoden-2.jpg" }
        ) {
          childImageSharp {
            gatsbyImageData(quality: 90, layout: FULL_WIDTH)
          }
        }
        crossCountry5: file(
          relativePath: { eq: "images/crosscountry/abisko-1.jpg" }
        ) {
          childImageSharp {
            gatsbyImageData(quality: 90, layout: FULL_WIDTH)
          }
        }
        bike1: file(
          relativePath: { eq: "images/mtb/ruska/anette_hetta_remote-46.jpg" }
        ) {
          childImageSharp {
            gatsbyImageData(quality: 90, layout: FULL_WIDTH)
          }
        }
        freeski1: file(
          relativePath: { eq: "images/freeski/kilpisjarvi-freeski-1.jpeg" }
        ) {
          childImageSharp {
            gatsbyImageData(quality: 90, layout: FULL_WIDTH)
          }
        }
        freeski2: file(relativePath: { eq: "images/freeski/kvaloya-2.jpg" }) {
          childImageSharp {
            gatsbyImageData(quality: 90, layout: FULL_WIDTH)
          }
        }
        onlineCourse1: file(
          relativePath: { eq: "images/verkkokurssi/verkkokurssi-1.jpg" }
        ) {
          childImageSharp {
            gatsbyImageData(quality: 90, layout: FULL_WIDTH)
          }
        }
      }
    `}
    render={(data) => {
      const sortCamps = () => {
        const camps = hiihtovaellukset.concat(vaellukset);

        const imagedCamps = camps.map((item) => {
          // Commented out - camp no longer exists
          // if (item.name === 'aloittelijoiden-vaellus-hetta-pallas-2025')
          //   return {
          //     ...item,
          //     gatsbyImageData: data.hike2.childImageSharp.gatsbyImageData,
          //   };
          if (item.name === 'aloittelijoiden-vaellus-hetta-pallas-2027')
            return {
              ...item,
              gatsbyImageData: data.hike2.childImageSharp.gatsbyImageData,
            };
          if (item.name === 'haltin-vaellus-2026')
            return {
              ...item,
              gatsbyImageData: data.hike3.childImageSharp.gatsbyImageData,
            };
          // Commented out - camp no longer exists
          // if (item.name === 'pohjois-norjan-vaellus')
          //   return {
          //     ...item,
          //     gatsbyImageData: data.hike4.childImageSharp.gatsbyImageData,
          //   };
          if (item.name === 'aloittelijoiden-hetta-pallas-hiihtovaellus')
            return {
              ...item,
              gatsbyImageData:
                data.crossCountry1.childImageSharp.gatsbyImageData,
            };
          // Commented out - camp no longer exists
          // if (item.name === 'haltin-hiihtovaellus')
          //   return {
          //     ...item,
          //     gatsbyImageData:
          //       data.crossCountry2.childImageSharp.gatsbyImageData,
          //   };
          if (
            item.name === 'kaamoshiihto-pallas-yllastunturin-kansallispuistossa'
          )
            return {
              ...item,
              gatsbyImageData:
                data.crossCountry3.childImageSharp.gatsbyImageData,
            };
          if (item.name === 'kasivarren-hiihtovaellus')
            return {
              ...item,
              gatsbyImageData:
                data.crossCountry2.childImageSharp.gatsbyImageData,
            };
          // Commented out - camp no longer exists
          // if (item.name === 'uuden-vuoden-voimaretki')
          //   return {
          //     ...item,
          //     gatsbyImageData:
          //       data.crossCountry4.childImageSharp.gatsbyImageData,
          //   };
          // Commented out - camp no longer exists
          // if (item.name === 'maastopyoravaellus-suomi-routsi-norja')
          //   return {
          //     ...item,
          //     gatsbyImageData: data.bike1.childImageSharp.gatsbyImageData,
          //   };
          // Commented out - camp no longer exists
          // if (item.name === 'naisten-finlav-lumiturvallisuus-1-yllas')
          //   return {
          //     ...item,
          //     gatsbyImageData: data.freeski2.childImageSharp.gatsbyImageData,
          //   };
          // if (item.name === 'kilpisjärven-vapaalaskuviikonloppu')
          //   return {
          //     ...item,
          //     gatsbyImageData: data.freeski1.childImageSharp.gatsbyImageData,
          //   };
          if (item.name === 'abiskon-hiihtovaellus-2026')
            return {
              ...item,
              gatsbyImageData:
                data.crossCountry5.childImageSharp.gatsbyImageData,
            };
          if (item.name === 'talviretkeilyn-turvallisuus')
            return {
              ...item,
              gatsbyImageData:
                data.onlineCourse1.childImageSharp.gatsbyImageData,
            };
          return {};
        });

        /*
          filter list of camps not not show current one and order
          them with the next in line beeing first
          */
        const campIndex = imagedCamps.findIndex((item) => item.name === camp);
        // arrange list and remove current one viewed from list
        if (campIndex === 0) return imagedCamps.slice(1, imagedCamps.length);

        return imagedCamps;
        // .slice(campIndex + 1, imagedCamps.length)
        // .concat(imagedCamps.slice(0, campIndex));
      };

      const sortedCamps = sortCamps();

      return (
        <SeeMore contentList={sortedCamps} headline="Katso lisää retkiä" />
      );
    }}
  />
);

export default SeeMoreCamps;
